import { mapActions } from 'vuex';
import CommonMixin from '@/mixins/templates/common';

import { ADialog } from 'core_a-dialog';
import { TemplateName } from '~/helpers/templateType';
import ApprovalStatus from '@/helpers/approvalStatus';

export default {
  mixins     : [CommonMixin],
  components : {
    ADialog
  },
  data() {
    return {
      TemplateName,
      isLoading    : false,
      isDisabled   : false,
      rejectReason : ''
    };
  },
  methods: {
    ...mapActions({
      actionPatchApprovalFlow: 'plataforma/newContent/actionPatchApprovalFlow'
    }),
    resetData() {
      this.rejectReason = '';
      this.isDisabled = false;
      this.isLoading = false;
    },
    disableSendRejectReasonButton() {
      return typeof this.rejectReason !== 'string' || !this.rejectReason.trim() || this.isLoading || this.isDisabled;
    },
    onConfirmReject(cancel, stopLoading) {
      this.isLoading = true;
      const params = {
        academicMainId : this.$route.params.courseId,
        data           : {
          approvalFlowStatusId : ApprovalStatus.PENDING_CORRECTION,
          comment              : this.rejectReason.trim()
        }
      };

      this.actionPatchApprovalFlow(params)
        .then(() => {
          this.$toast.success(this.$t('approvalFlow.approveModelCourse.confirmRejectDialog.rejectSuccessMessag'));
          cancel();
        })
        .catch((err) => {
          this.$toast.error(err.data.error.message);
        })
        .finally(() => {
          stopLoading();
          this.resetData();
        });
    }
  }
};
